module.exports = __webpack_public_path__ + "static/assets/b2131d1134e905f81476b5774eee869c.png";